module.exports = __webpack_public_path__ + "img/LifeBtn.8e8c1f7c.svg";